module.exports = __webpack_public_path__ + "img/antes_despues_10.34482b95.png";